import React from 'react';
import { HIGHLIGHTERS, Highlighter } from '../../lib/paper';

/**
 * A highlighter swipe behind its children (usually a word of a heading), swept
 * on left-to-right when it mounts — covers the lower ~half, like a marker pass.
 */
export const Highlight: React.FC<{
  tone?: Highlighter;
  className?: string;
  children: React.ReactNode;
}> = ({ tone = HIGHLIGHTERS.yellow, className = '', children }) => (
  <span className={`relative inline-block ${className}`}>
    <span
      aria-hidden
      className="pb-sweep absolute bottom-[8%] left-[-4px] right-[-6px] h-[52%] -rotate-[1.2deg] rounded-md"
      style={{ backgroundColor: tone.fill }}
    />
    <span className="relative">{children}</span>
  </span>
);
